import React from "react";
import "./Footer.css";
import { Fade } from "react-reveal";
import { greeting } from "portfolio";

const Footer = (props) => {
  const fullYear = new Date().getFullYear();
  return (
    <div className="footer-div">
      <Fade>
        <p className="footer-text" style={{ color: props.theme.text }}>
          Copyright  &copy; {fullYear} <span role="img" aria-label="earth">🌍</span> {greeting.title}
        </p>
      </Fade>
    </div>
  );
}

export default Footer;